export default __webpack_public_path__ + "static/media/check-round-outline-white-16px.92051919.svg";